import img1 from "@/assets/img/team/p1.png";
import img2 from "@/assets/img/team/p2.png";
import img3 from "@/assets/img/team/p3.png";
import img4 from "@/assets/img/team/p4.png";
import img5 from "@/assets/img/team/p5.png";
import img6 from "@/assets/img/team/p6.png";
import img7 from "@/assets/img/team/p7.png";
export const teamList: TeamItem[] = [
  {
    id: 1,
    name: "Cynthia Zhang",
    pos: "Founding Partner",
    img: img1,
    content: [
      "Cynthia Zhang, a visionary investor with over a decade of global market experience, leads FutureX Capital's investments in high-growth, deep-tech enterprises. Her track record includes investments totaling over RMB 20 billion in industry giants such as ByteDance, NIO, Meituan, Xiaomi, and Alibaba.",
      "Before founding FutureX Capital, Cynthia established and led the Private Equity Division at China Asset Management Company. Her expertise spans TMT, consumer, healthcare, and finance sectors, honed through roles at Merrill Lynch, UBS, and Delta Partners.",
      "Cynthia's investment philosophy centers on transformative technologies with global impact, firmly grounded in industry fundamentals. At FutureX, she's building the X-Network, uniting elite minds to uncover groundbreaking opportunities.",
      "Cynthia holds a Master's in Finance from Tsinghua University, an honorary degree in Computer Science from the National University of Singapore, and an MBA with honors from Hult International Business School. She also holds a CFA qualification and is an alumna of Stanford GSB.",
    ],
  },
  {
    id: 2,
    name: "Yvonne Chau",
    pos: "MANAGING Partner / CFO",
    img: img2,
    content: [
      "Yvonne Chau joined FutureX in 2018 and currently serves as Managing Partner and CFO. Her prior extensive financial experience includes founding and leading a boutique asset management company managing $1 billion in assets.",
      " Previously, as Head of Regulatory Reporting at Standard Chartered Bank, Yvonne managed compliance reporting and supervised financial risks, collaborating closely with Treasury and Legal departments. Her role as the primary liaison between the bank and regulators honed her regulatory expertise.",
      " Yvonne's career also includes eight years at Arthur Andersen and PricewaterhouseCoopers, where she provided consulting services in finance, risk management, performance improvement, M&A, and IPO transactions to various international financial institutions and corporations. Her client portfolio included AIG Group, Bank of China Group, Invesco Asset Management, and Sumitomo Trust, among others.",
      "Yvonne has 20 years of management experience and holds a BBA from the Hong Kong Polytechnic University. She has earned designations from the Hong Kong Institute of Certified Public Accountants (HKICPA) and the Association of Chartered Certified Accountants (ACCA).",
    ],
  },
  {
    id: 3,
    name: "William Zhang",
    pos: "Managing Partner",
    img: img3,
    content: [
      "William (Hanqin) Zhang leads FutureX Capital's investment execution and research efforts. Since joining in 2018, he has been instrumental in managing high-profile deals including Kingsoft Cloud, ByteDance, and Meituan. His deep expertise spans TMT, education, consumer, and financial sectors.",
      "Prior to FutureX, William's career included roles at Deutsche Bank, where he led significant projects such as Inke's Hong Kong listing, Bright Scholar Education's US listing, and a major news app's US listing. At Standard Chartered Bank, he developed key publications on the RMB market. William's diverse experience spans Hong Kong, London, and Shanghai, including roles at HSBC and KPMG.",
      "William holds a Master's in Finance and Economics from the London School of Economics and a Bachelor's in Economics from the University of Cambridge.",
    ],
  },
  // {
  //   id: 4,
  //   name: "Edward Huang",
  //   pos: "Managing Partner",
  //   img: img4,
  //   content: [
  //     "Edward (Kai) Huang brings over 20 years of investment experience focused on technology and innovation to FutureX Capital. His deep understanding of technological trends has enabled him to identify and nurture high-potential companies, with notable successes including ByteDance, Smartsense, and Longcheer.",
  //     "Kai's career spans prestigious firms, including a tenure as CEO at Goldhorse Capital Management (2014-2017) and Portfolio Manager at CITIC Securities International Investment Management. Earlier in his career, he developed his expertise in portfolio management and investment analysis at Balyasny Asset Management, The D. E. Shaw Group, SAC Capital, and Credit Suisse, working across various strategies and asset classes.",
  //     "With a Ph.D. in Computational Biology from Carnegie Mellon University and a B.S. from Tsinghua University, Kai brings a unique scientific perspective to tech investing.",
  //   ],
  // },
 
  {
    id: 5,
    name: "Alex Cheung",
    pos: "Head of Operations",
    img: img7,
    content: [
      "Alex Cheung oversees fund management and regulatory compliance at FutureX Capital. With over a decade of experience, he develops and implements operational policies, ensuring adherence to local and international regulations. Alex monitors fund performance, conducts thorough compliance audits, and coordinates with legal and financial advisors to maintain high standards of governance and transparency.",
      "Prior to FutureX, Alex held senior positions in asset management, fund administration firms, and a global bank, where he focused on tech and innovation-driven companies in both public and private markets.",
      "Alex holds a Master's in Corporate Governance from The Hong Kong Polytechnic University and is an Associate Member of HKCIA and ICSA.",
    ],
  },
  {
    id: 8,
    name: "",
    pos: "",
    img: "",
    content: [],
  },
];
